module.exports = __webpack_public_path__ + "img/item-info-icon1_r.5d3fee2e.svg";